import { combineReducers } from 'redux';
import { State } from './state';
import jobOffersReducer from '../api/jobOffers/jobOffers.reducer';
import jobOfferApplicationReducer from '../api/jobOfferApplication/jobOfferApplication.reducer';

export default () =>
    combineReducers<State, any>({
        jobOffers: jobOffersReducer,
        jobOfferApplication: jobOfferApplicationReducer
    });
